import React from 'react';
import { BlogSidebarCard } from './blog-sidebar-card';

interface BlogSidebarItemProps {
	icon: React.ReactNode;
	title: string;
	headerClassName?: string;
	contentClassName?: string;
	footerClassName?: string;
	children: React.ReactNode;
	footer?: React.ReactNode;
}

export const BlogSidebarItem = ({
	icon,
	title,
	headerClassName,
	contentClassName,
	footerClassName,
	children,
	footer,
}: BlogSidebarItemProps) => {
	return (
		<BlogSidebarCard
			icon={icon}
			title={title}
			headerClassName={headerClassName}
			contentClassName={contentClassName}
			footerClassName={footerClassName}
			footer={footer}>
			{children}
		</BlogSidebarCard>
	);
};
